import { PrivacyModalComponent } from './../privacy-modal/privacy-modal.component';
import { LoginService } from './../services/login.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RequestBuilder } from '../classes/request-builder';
import { IUserCheck, IUserLogin } from '../interfaces/IUserLogin';
import { AlertUtil } from '../utils/alert-util';
import { Loading } from '../utils/loading';
import * as Constants from '../utils/constants'
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/api';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  userLogin: IUserLogin
  L = Loading
  appVersion: string
  imagePath: string     //imagePath logo
  wbBaseUrl: string    // base url from Constants
  @Output() loginEmitter: EventEmitter<boolean> = new EventEmitter()

  constructor(private formBuilder: FormBuilder,
    private loginService: LoginService,
    private alertUtil: AlertUtil,
    private translate: TranslateService,
    private dialogService: DialogService) { }

  ngOnInit() {
    this.appVersion = Constants.APP_VERSION
    this.wbBaseUrl = Constants.WS_BASE_URL
    this.setLogoAndStyle();

    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  /**
   * Controllo versione app per cambio logo e relativi stili
   */
  private setLogoAndStyle() {
    this.imagePath = "./assets/images/LogoLegalileo.png";
  }

  // convenience getter for easy access to form fields
  get form() { return this.loginForm.controls; }

  /**
   * click login button
   */
  onClickLogin() {
    if (this.loginForm.valid) {

      let username = this.loginForm.controls['username'].value
      let password = this.loginForm.controls['password'].value
      this.userLogin = {
        ApplicationName: "/",
        Username: username,
        Email: "",
        Password: password,
        UserId: "",
        RoleId: "",
        RoleName: "",
        AppVersion: this.appVersion
      }
      this.callLoginService(this.userLogin)
    }
  }

  /**
   * call to login service
   * @param userLogin userLogin obj
   */
  callLoginService(userLogin: IUserLogin) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(userLogin)
    this.loginService.login(reqBuilder).subscribe(
      response => {
        Loading.isLoading = false
        if (response.data) {
          this.saveLoginDataInStorage(response.data)
          //this.emitLogin()
          this.checkUserGdpr(userLogin);
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        } else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        Loading.isLoading = false
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }


  /**
   * MODIFICA 30/11/2020 (CR)
   * set interface and call service for check GDPR
   */
  private checkUserGdpr(userLogin: IUserLogin) {
    let userCk: IUserCheck = {
      Username: userLogin.Username
    };
    this.callCheckGDPRService(userCk);
  }

  /**
   * save data in local storage
   * @param response login response
   */
  saveLoginDataInStorage(response: IUserLogin) {
    localStorage.setItem(Constants.LS_USER_GUID, response.UserId)
    localStorage.setItem(Constants.LS_USER_TYPE, "0")
    localStorage.setItem(Constants.LS_USER_ROLE, response.RoleName)
    localStorage.setItem(Constants.LS_USERNAME, response.Username)
    localStorage.setItem(Constants.LS_ESECUTORE, null)
    localStorage.setItem(Constants.LS_RAG_SOCIALE, response.RagioneSociale ? response.RagioneSociale : '')
  }

  /**
   * emit and show home
   */
  emitLogin() {
    this.loginEmitter.emit(true);
  }

  /**
   * check privacy for user and open modal
   */
  openPrivacyModal() {
    //get header translation
    this.translate.get(["LBL_PRIVACY_HEADER"]).subscribe(res => {
      //open gruppo modal
      let gruppoModal = this.dialogService.open(PrivacyModalComponent, {
        data: {
          UserId: localStorage.getItem(Constants.LS_USER_GUID)
        },
        header: res["LBL_PRIVACY_HEADER"],
        width: '65%'
      })


      gruppoModal.onClose.subscribe((data) => {
        if (data) {
          this.emitLogin()
        }
      })
    })
  }


  /**
   * call to check gdpr service
   */
  callCheckGDPRService(userCheck: IUserCheck) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(userCheck)
    this.loginService.checkGDPR(reqBuilder).subscribe(
      response => {
        Loading.isLoading = false
        if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        } else if (response.data && !response.data.PrivacyFlag) {
          this.openPrivacyModal()
        } else if (response.data.PrivacyFlag) {
          this.emitLogin()
        } else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        Loading.isLoading = false
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }
}
